import { Suspense } from "react";
import "./App.css";
import Routes from "./router";

function App() {
  return <Suspense>{Routes.useRenderRoutes()}</Suspense>;
}

export default App;
